import Model from "./Model";

class Keyword extends Model {
    getId() {
        return this.attrs.id;
    }
    
    setId(value) {
        this.attrs.id = value;
        return this;
    }

    getServiceId() {
        return this.attrs.serviceId;
    }
    
    setServiceId(value) {
        this.attrs.serviceId = value;
        return this;
    }

    getKeyword() {
        return this.attrs.keyword;
    }
    
    setKeyword(value) {
        this.attrs.keyword = value;
        return this;
    }

    getTriggerNo() {
        return this.attrs.triggerNo;
    }
    
    setTriggerNo(value) {
        this.attrs.triggerNo = value;
        return this;
    }

    getMatchMethod() {
        return this.attrs.matchMethod;
    }
    
    setMatchMethod(value) {
        this.attrs.matchMethod = value;
        return this;
    }

    getReplyMaterial() {
        return this.attrs.replyMaterial;
    }
    
    setReplyMaterial(value) {
        this.attrs.replyMaterial = value;
        return this;
    }

    getChatbotId() {
        return this.attrs.chatbotId;
    }
    
    setChatbotId(value) {
        this.attrs.chatbotId = value;
        return this;
    }

    getChatbotName() {
        return this.attrs.chatbotName;
    }
    
    setChatbotName(value) {
        this.attrs.chatbotName = value;
        return this;
    }

     getTemplateId() {
        return this.attrs.templateId;
    }
    
    setTemplateId(value) {
        this.attrs.templateId = value;
        return this;
    }
}
export default Keyword;